import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Utilerias } from 'src/app/helpers/Utilerias';
import { ChecklistService } from 'src/app/services/configuracion/checklist.service';
import { Checklist } from 'src/app/types/type';
declare var $: any;

@Component({
  selector: 'app-form-duplicar-checklist',
  templateUrl: './form-duplicar-checklist.component.html',
  styleUrls: ['./form-duplicar-checklist.component.css']
})
export class FormDuplicarChecklistComponent {
  @Input() idCheckList: number;
  @Output() emitDuplicado = new EventEmitter();
  form: FormGroup;

  constructor(private formBuilder: FormBuilder, private checklistService: ChecklistService) {
    this.form = this.formBuilder.group({
      nombreCheckListDuplicado: ['', [Validators.required]],
    });
  }

  duplicarChecklistHandler() {
    if (this.form.valid) {
      $('#modalNombreCheckList').modal('hide');
      Utilerias.showLoaderSwal();

      const { nombreCheckListDuplicado } = this.form.value;

      this.checklistService
        .postDuplicarCheckList(this.idCheckList, nombreCheckListDuplicado)
        .subscribe(response => {
          if (response.Result.Exito) {
            this.emitDuplicado.emit(response.Result.Data as Checklist);
          }
        });
    }
  }
}
